import { GeoCoderClient } from 'services/api/APIClientGeocoder'

export const BASE_KEY = '/v1/search'

export const fetchResults = (term: string) => {
    return GeoCoderClient.get(`${BASE_KEY}/${term}`)
}
